import React from 'react';
import logo from '../../logo.svg';
import './hero.css';

function Hero(props) {
    return(
        <div className="hero wrapper">
            <img className="hero-logo" src="https://res.cloudinary.com/rmkt/image/upload/v1597039398/techopps/TechOpps-Final-Logo-Icon_romj7h.png" alt={'techoppsemail'}/>
            <div className="hero-text">
                <h1 ><strong>{props.title}</strong></h1>
                <h3 >{props.sub}</h3>
            </div>
            {/* <div className="hero-img">
                <img src="https://res.cloudinary.com/rmkt/image/upload/v1597038564/techopps/hero_lltkd9.png" alt={'herotechopps'} />
            </div> */}
        </div>
    );
}

export default Hero;